// LiveStreamAnimationGift.js
'use strict';
import { connect } from 'react-redux';

import LiveStreamAnimationGift from '../component/LiveStreamAnimationGift.jsx';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getListData from '../selector/getListData.js';
import getGiftData from '../selector/getGiftData.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { livestreamNoticeType } from '../resource/liveStreamConstants.js';
import { LIVESTREAM_ANIMATION_PAG_GIFTS } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { streamId }) => {
  const noticeType = livestreamNoticeType.GIFT_NOTICE;
  const giftNoticeIds =
    getListData(state, ['liveStream', streamId, noticeType], 'itemIds') || [];
  const giftNoticeId = giftNoticeIds[0];
  const giftNoticeSelectPath = [streamId, noticeType, giftNoticeId];
  const giftId = getLiveStreamData(state, giftNoticeSelectPath, 'giftId');
  const senderId = getLiveStreamData(state, giftNoticeSelectPath, 'senderId');
  const meId = getMeData(state, 'id');
  const isSender = !!(senderId && meId && senderId === meId);
  const giftImage = giftId ? getGiftData(state, giftId, 'largeImage') : '';

  // PAG gift support
  const pagGiftList =
    getRemoteConfigData(state, LIVESTREAM_ANIMATION_PAG_GIFTS) || [];
  const isPagGift = giftId ? pagGiftList.includes(giftId) : false;
  const pagImage =
    giftId && isPagGift ? getGiftData(state, giftId, 'pagImage') : '';

  const byteplusUsingPlayer = getLiveStreamData(
    state,
    [streamId, 'byteplus'],
    'usingPlayer'
  );
  const byteplusPlayerVideoHeight = getLiveStreamData(
    state,
    [streamId, 'byteplus', byteplusUsingPlayer],
    'videoHeight'
  );
  const byteplusPlayerVideoWidth = getLiveStreamData(
    state,
    [streamId, 'byteplus', byteplusUsingPlayer],
    'videoWidth'
  );

  return {
    byteplusPlayerVideoWidth,
    byteplusPlayerVideoHeight,
    giftNoticeId,
    giftId,
    streamId,
    isSender,
    giftImage,
    pagImage,
    isPagGift,
    shouldShowMainAsset: getLiveStreamData(
      state,
      giftNoticeSelectPath,
      'shouldShowMainAsset'
    ),
  };
};

export default connect(mapStateToProps, null)(LiveStreamAnimationGift);
